import { resource } from "../http";

const School = resource("/school");

export default School;
